/****************************************************
 * Module Name:  addCustomersettingsModalWrapper.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import React, { Component } from "react";
import { Box } from "@mui/material";
import { Spinner } from "react-bootstrap";

import Constants from "../../utility/constants";
import CommonSnackbar from "../common/commonSnackBar";
import AddCustomersettingsModal from "./addCustomersettingsModal";
import CustomerFTPsettingsProxy from "../../utility/proxy/manager/customerFTPsettingsProxy";
import CustomerApiSettingsModal from "./customerApiSettingsModal";
import CustomerAPISettingsProxy from "../../utility/proxy/manager/customerAPISettingsProxy";

export default class AddCustomersettingsModalWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showLoading: this.props.loadData && this.props.customerId,
      sourceData: {},
      editOperation: false,
      errorSnackbar: false,
      loadingButton: false,
    };

    if (this.props.loadData && this.props.customerId) {
      if (this.props.isFTPModal) {
        CustomerFTPsettingsProxy.GetSingleCustomerFTPsettingsById(
          this.props.customerId,
          (responseData) => {
            if (responseData) {
              this.setState({
                showLoading: false,
                editOperation: responseData.customerid === this.props.customerId ? true : false,
                sourceData: responseData
              })

            } else {
              this.setState({ showLoading: false, editOperation: false, sourceData: {} })
            }
          }
        )
      } else {
        CustomerAPISettingsProxy.GetSingleCustomerAPIsettingsById(
          this.props.customerId,
          (responseData) => {
            if (responseData) {
              this.setState({
                showLoading: false,
                editOperation: responseData.userid === this.props.customerId ? true : false,
                sourceData: responseData
              })
            } else {
              this.setState({ showLoading: false, editOperation: false, sourceData: {} })
            }
          }
        )
      }
    }
  }

  handleFtpSave = (customersettingsData) => {
    //Updating customerFTPsettings, and once customerFTPsettings is updated on call refresh the list of current customerFTPsettings
    this.setState({ loadingButton: true });
    CustomerFTPsettingsProxy.UpdateCustomerFTPsettings(customersettingsData, (response) => {
      if (response) {
        this.setState({ loadingButton: false, editOperation: false });
        //Hidding customerFTPsettings modal
        this.props.handleClose();
        this.props.handleSave();
      } else {
        this.setState({
          loadingButton: false,
          errorSnackbar: true,
          editOperation: false
        });
      }
    });
  };

  handleApiSave = (customerApisettingsData) => {
    this.setState({ loadingButton: true });
    CustomerAPISettingsProxy.CreateOrUpdateCustomerAPIsettings(customerApisettingsData, (response) => {
      if (response) {
        this.setState({ loadingButton: false, editOperation: false });
        //Hidding customerFTPsettings modal
        this.props.handleClose();
        this.props.handleSave();
      } else {
        this.setState({
          loadingButton: false,
          errorSnackbar: true,
          editOperation: false
        });
      }
    });
  }

  handleValidation = (customersettingsData) => {
    //TODO do validation if needed here
    return true;
  };

  render() {
    return (
      <div>
        <CommonSnackbar
          show={this.state.errorSnackbar}
          message={<Box>{Constants.APiFailErrorMessage}</Box>}
          variant={"error"}
          autoHide={Constants.SnackBarCloseTimer}
          handleClose={() => this.setState({ errorSnackbar: false })}
          title="Failed"
        />
        {this.state.showLoading ? (
          <CommonSnackbar
            show={true}
            message={
              <Box>
                <Spinner size="lg" animation="border" /> &nbsp;&nbsp; Loading...{" "}
              </Box>
            }
            variant={"info"}
            autoHide={false}
            handleClose={this.props.handleClose}
            title={this.props.isFTPModal ? "Retrieving Customer FTP Settings" : "Retrieving Customer API Settings"}
          />
        ) : <>
          {this.props.isFTPModal ? (
            <AddCustomersettingsModal
              Show={true}
              handleClose={this.props.handleClose}
              handleSave={this.handleFtpSave}
              customerId={this.props.customerId}
              handleValidation={this.handleValidation}
              editOperation={this.state.editOperation}
              sourceData={this.state.sourceData}
              loading={this.state.loadingButton}
            />
          ) : (
            <CustomerApiSettingsModal
              Show={true}
              loading={this.state.loadingButton}
              customerid={this.props.customerId}
              handleClose={this.props.handleClose}
              handleSave={this.handleApiSave}
              editOperation={this.state.editOperation}
              sourceData={this.state.sourceData}
            />
          )
          }
        </>
        }
      </div>
    )
  }
}